import type { ReactNode } from 'react';
import styles from './IconButton.module.css';

interface IconButtonProps {
  icon: ReactNode;
  'aria-label': string;
  variant?: 'ghost' | 'solid';
  size?: 'sm' | 'md';
  onClick?: () => void;
}

export function IconButton({
  icon,
  'aria-label': ariaLabel,
  variant = 'ghost',
  size = 'md',
  onClick,
}: IconButtonProps) {
  return (
    <button
      type="button"
      className={`${styles.iconButton} ${styles[variant]} ${styles[size]}`}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}
